module.exports = __webpack_public_path__ + "static/media/17.2bee0a0d.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/components/Charities/brands/17.jpg
// module id = 587
// module chunks = 0